import React from "react";
import styled from "styled-components";
import { A, H2, H4, IconFacebook, IconInstagram, IconTwitter, P } from "@upsolve/ui";
import { graphql, useStaticQuery } from "gatsby";

import ImageStaticMap from "../components/Media/ImageStaticMap";
import MainFooter from "../components/Layout/Footer";
import MainHeader from "../components/Layout/Header";
import SEO from "../components/SEO/SEO";
import TopLevelLayout from "../components/Layout/TopLevelLayout";

const ContactStyled = styled.div`
  margin: 3em 0;
  padding: 0 20%;
  @media (max-width: 45em) {
    padding: 0 5%;
  }
  & > div {
    margin: 0.75em 0;
  }
  .contact__header {
    text-align: center;
  }
  .contact__body {
    width: 100%;
    margin: 1em 0 0 0;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    @media (max-width: 45em) {
      flex-direction: column-reverse;
      img {
        width: 100%;
        height: auto;
      }
    }
    & > div {
      padding: 1em;
      width: 100%;
    }
    .rohan-and-ivetty {
      width: 100%;
    }
    img {
      border-radius: 12px;
      box-shadow: 10px 10px 78px 0 rgba(0, 0, 0, 0.2);
    }
  }
  .contact__map {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    @media (max-width: 45em) {
      flex-direction: column-reverse;
      img {
        width: 100%;
        height: auto;
      }
    }
    & > div {
      padding: 1em;
    }
    .mailing-address {
      padding-left: 2em;
      @media (max-width: 45em) {
        padding-left: 0;
      }
    }
    img {
      border-radius: 12px;
      box-shadow: 10px 10px 78px 0 rgba(0, 0, 0, 0.2);
    }
  }
  .contact__socials {
    text-align: center;
    width: 100%;
    .socials-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 1em;
      a {
        margin: 0 1em;
      }
      svg {
        height: 32px;
        width: 32px;
        path,
        circle {
          fill: ${(props) => props.theme.colors.brand[500]};
        }
      }
    }
  }
`;

const ContactPage = () => {
  const data = useStaticQuery(graphql`
    query IvettyAndRohanQueryContactPage {
      imageIvettyAndRohan: file(base: { eq: "ivetty-and-rohan.jpg" }) {
        childImageSharp {
          fixed(quality: 90, width: 450) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  return (
    <TopLevelLayout>
      <div className="index-container">
        <SEO title="Contact Us | Upsolve" description="Upsolve Contact" url="https://upsolve.org/contact/" />
        <MainHeader />
        <main>
          <ContactStyled>
            <div className="contact__header">
              <H2>Get in touch</H2>
              <P>Want to get in touch? We&apos;d love to hear from you. Here&apos;s how you can reach us...</P>
            </div>
            <div className="contact__body">
              <div>
                <div>
                  <P>
                    Need help with one of our applications? Visit our{" "}
                    <A href="https://help.upsolve.org/hc/en-us">Help Center</A> for assistance.
                  </P>
                  <P>
                    For press, donors inquiries, and speaking engagements:
                    <br />
                    Email <A href="mailto:fernando@upsolve.org">fernando@upsolve.org</A>
                  </P>
                </div>
              </div>
              <div className="rohan-and-ivetty">
                <img alt="Rohan and Ivetty" src={data.imageIvettyAndRohan.childImageSharp.fixed.src} />
              </div>
            </div>
            <div className="contact__map">
              <div>
                <ImageStaticMap latitude={40.761635} longitude={-73.971802} height={150} width={250} />
              </div>
              <div>
                <div className="mailing-address">
                  <H4>Mailing Address</H4>
                  <P>Upsolve</P>
                  <P>228 Park Ave S</P>
                  <P>PMB 53933</P>
                  <P>New York, NY 10003</P>
                </div>
              </div>
            </div>
            <div className="contact__socials">
              <H4>Social</H4>
              <div className="socials-row">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/upsolvebankruptcy/">
                  <IconFacebook />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/upsolve/">
                  <IconInstagram />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/upsolvebk">
                  <IconTwitter />
                </a>
              </div>
            </div>
          </ContactStyled>
        </main>
        <MainFooter />
      </div>
    </TopLevelLayout>
  );
};

export default ContactPage;